export const BASE_URL : string = 'api/SetupModel'

export class ModelSetupVM {
         model_auto :number
         make_auto :number
         type_auto :number 
         service_cycle_type_auto :number
         equip_reg_industry_auto :number
         typeid :string
         typedesc :string
         makeid:string
         makedesc :string
         modelid :string
         modeldesc:string
         created_date :string
         created_user :string
         modified_date :string
         modified_user :string
         ModelNote :string
         ModelImage :string
         service_cycle_type :string
         s_cycle_type_description :string
         industry_name :string

         uploadToMobile:boolean;
         ModelImageLeft:string;
         ModelImageRight:string;
         IsRightImageRotate:boolean;
}

export class ComponentList{
    compartid_auto:number
    model_auto:number
    comartid:string
    compart:string
    comparttype_auto:number
    comparttypeid:string
    comparttype:string
    make_auto:number
    makeid:string
    makedesc:string
    compart_note:string

}

export class ModelBaseObservations{
    Id:number
    Title:string
    Type:string
    Image:string
    ToolImage:string
    Min:number
    Max:number
    Active:boolean
    EnableData:boolean

}
export class ServiceCycleVM
{
    Id:number
    Title:string
}

export class UnitNumberVm
{
  UnitNumber:string
}

export class Industry
{
    Id:number
    Title:string
}
export class ComponentType {

    Typeid: string
    Order: number;
}
export class PartlineModel {

    Id: string
    Name: number;
}

export interface ChainInfoModel {
    ModelAuto: number;
    ChainAutoId: number;
    Description: string;
    MmtaIdAuto: number;
    SeriesId?: number;
    ModelSerialNumberStart: string;
    ModelSerialNumberEnd: string;
    NumberOfLinks?: number;
    NumberOfIdlers?: number;
    NumberOfCarrierRollers?: number;
    NumberOfTrackRollers?: number;
    Pitch?: number;
    BoltHoleDiameter?: number;
    LinkHeight?: number;
    BushingOD?: number;
    ChainInsideSpread?: number;
    ChainOutsideSpread?: number;
  }

  export interface ChainDescriptionModel {
    ChainAutoId: number;
    ChainDescription: string;
    ModelSerialNumberStart: string;
    ModelSerialNumberEnd: string;
    Pitch: number;
    NumberOfLinks: number;
  }

export interface ChainActivePartModel {
    PartNumber: string;
    CompartType: string;
    CompartId: number;
    Quantity: number;
    Cost: number;
    isActive: number;
    CostTotal: number;
    QuantityReq: number;
    AddToQuote: number;
    PartConfigCompAuto:number;
}

export class DealershipsCustomers {
    customer_auto: number;
    cust_name: string;
}

export class UserDealerGroupDealerships {
    DealershipId: number;
    DealerShipName: string;
}
export class UserDealerGroup {
    Id: number;
    Name: string;
    Email:string;
}

export class PartConfiqQuoteBillingDetails {
    UserId: number;
    DealerGroupId: number;
    DealershipId: number;
    CustomerId: number;
    FirstName: string;
    LastName: string;
    EmailId: string;
    ChainId: number;
    ContactNumber: number;
    BillingAddress: string;
    DeliveryAddress: string;

}
export class ChainActivePartVM {
    chainPartData: ChainActivePartModel[]=[];
    chainId: number=0;
    partQuoteId: number=0;
}

export interface UserQuoteHistory {
    PartQuoteId: number;
    HistoryDate: Date;
    TotalCost: number;
    ChainDescription:string
  }


